module.exports = __webpack_public_path__ + "img/story046.ba875754.webp";